// src/components/FullScreenLoader.jsx
import React from "react";

const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 z-50 bg-white flex flex-col items-center justify-center transition-opacity duration-300">
      <div
        className="animate-spin rounded-full h-16 w-16 border-t-4 border-gray-300 mb-4"
        style={{ borderTopColor: "#ee4799" }}
      />
      <p className="text-gray-600 text-sm animate-pulse">Loading, please wait...</p>
    </div>
  );
};

export default FullScreenLoader;
